import { global } from '../constants';

export const data = {
	banner: {
		background: global.banner + '1.jpg',
		title: 'About Us',
		crumb: 'About Us',
	},

	whatwedo: {
		title: 'What we do!',
		subtitle: 'Specialist Logistics Services',
		description:
			'Lorem Ipsum is simply dummy text of the printing and typesetting industry the standard dummy text ever since the when an printer took.',
		image: global.icons + 'img1.png',
		works: [
			{
				icon: global.icons + 'pic1.png',
				serial: '01.',
				title: 'Road Freight',
				description:
					'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt',
			},
			{
				icon: global.icons + 'pic2.png',
				serial: '02.',
				title: 'Shipping Freight',
				description:
					'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt',
			},
			{
				icon: global.icons + 'pic3.png',
				serial: '03.',
				title: 'Air Freight',
				description:
					'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt',
			},
		],
	},

	achivements: [
		{
			count: '120',
			title: 'Warehouses in Worldwide',
		},
		{
			count: '18',
			title: 'Year of experience',
		},
		{
			count: '60',
			title: 'Kg Minimum lot volume',
		},
	],

	testimonials: {
		title: 'Respected',
		subtitle: 'Clients & partners',
		clients: [
			global.logo + '/w1.png',
			global.logo + '/w2.png',
			global.logo + '/w3.png',
			global.logo + '/w4.png',
			global.logo + '/w5.png',
			global.logo + '/w6.png',
		],
		partners: [
			{
				pic: global.testim + 'pic1.jpg',
				name: 'Peter Len',
				designation: 'Art Dealer',
				quote:
					'Helped move my art collection with care and precision. Highly recommend! Their team was professional and attentive to detail. I felt confident in their ability to handle my valuable pieces. From the initial consultation to the final delivery, every step was handled with expertise and genuine concern for my requirements. The communication was clear and timely and they went above and beyond to ensure my satisfaction.',
			},
			{
				pic: global.testim + 'pic2.jpg',
				name: 'Giselle',
				designation: 'Business Owner',
				quote:
					'Exceptional service! They handled my gold shipment with utmost care and efficiency. I felt secure throughout the entire process. Highly recommend them for any precious metals logistics needs. Their team was knowledgeable and provided clear guidance at every step. The packaging and handling exceeded my expectations, ensuring my shipment arrived safely and on time.',
			},
			{
				pic: global.testim + 'pic3.jpg',
				name: 'Josephine',
				designation: 'Jewelry Designer',
				quote:
					'Their team handled my jewelry shipment with the utmost care. I couldn’t be happier with their service! Highly recommend them for any jewelry logistics needs. From the moment I contacted them, their professionalism and attention to detail were evident. They provided clear communication throughout the process and ensured my valuable pieces were packaged securely. ',
			},
			{
				pic: global.testim + 'pic4.jpg',
				name: 'Penelope',
				designation: 'Bank Manager',
				quote:
					'Made my bank note shipment a breeze. Their attention to detail and security measures were top-notch. I highly recommend them for any sensitive shipments. From the initial inquiry to the final delivery, their team demonstrated professionalism and a deep understanding of secure logistics. Communication was prompt and transparent, and every step was handled with utmost care.',
			},
		],
	},

	blogs: {
		title: 'Our Blogs',
		subtitle: 'Recent news & events',
		description:
			'Lorem Ipsum is simply dummy text of the printing and typesetting industry the standard dummy text ever since the when an printer took.',
		blogs: [
			{
				image: global.blog1 + 'bg1.jpg',
				day: '02',
				month: 'Aug',
				title:
					'At the end of the day, going forward, a new normal that has evolved from.',
				description:
					'New chip traps clusters of migrating tumor cells asperiortenetur, blanditiis odit.',
			},
			{
				image: global.blog2 + 'l-1.jpg',
				day: '08',
				month: 'Aug',
				title:
					'How all this mistaken idea denouncing pleasure and praising pain was.',
				description:
					'New chip traps clusters of migrating tumor cells asperiortenetur, blanditiis odit.',
			},
			{
				image: global.blog1 + 'bg3.jpg',
				day: '21',
				month: 'Aug',
				title: 'Going forward, a new normal that has evolved from generation.',
				description:
					'New chip traps clusters of migrating tumor cells asperiortenetur, blanditiis odit.',
			},
		],
	},

	approach: {
		title: 'Company Approch',
		subtitle: 'Reliable Logistic & Transport Solutions',
		yearsOfExperience: '18',
		specifications: [
			{
				icon: global.icons + 'c-pic1.png',
				count: '195',
				title: 'Professional Staff',
			},
			{
				icon: global.icons + 'c-pic2.png',
				count: '250',
				title: 'On Time Delievery',
			},
			{
				icon: global.icons + 'c-pic3.png',
				count: '350',
				title: 'Technology and Media',
			},
		],
	},
};
